import { api } from '@/services/api/AxiosBaseService'

/** Um colaborador dentro da fatura projetada da empresa. */
export interface ProjectionLine {
  id: string
  name: string
  planName: string | null
  planAmount: number
  discount: number
  total: number
  couponCode: string | null
  installment: number | null
}

/** Comissão que a fatura projetada vai gerar. */
export interface ProjectionCommission {
  id: string
  userName: string
  type: string | null
  amount: number
  /** true = a Ampla paga; false = repasse interno entre parceiros. */
  paidByCompany: boolean
}

export interface ProjectionItem {
  id: string
  kind: 'assinante' | 'empresa'
  name: string
  document: string | null
  planName: string | null
  paymentMethod: string
  dueDate: string | null
  planAmount: number
  discount: number
  total: number
  couponCode: string | null
  collaboratorsCount: number
  skipped: boolean
  adjusted: boolean
  adjustNote: string | null
  lines: ProjectionLine[]
  commissions: ProjectionCommission[]
  commissionsTotal: number
  formatted: { dueDate: string | null; total: string }
}

export interface Projection {
  run: {
    id: string
    month: string
    /** SNAPSHOT vale para a cobrança; PREVIA é só acompanhamento. */
    kind: 'PREVIA' | 'SNAPSHOT'
    takenAt: string | null
    formatted: { takenAt: string | null }
    totals: {
      subscribersCount: number
      companiesCount: number
      subscribersTotal: number
      companiesTotal: number
      commissionsTotal: number
      grandTotal: number
    }
  }
  subscribers: ProjectionItem[]
  companies: ProjectionItem[]
}

/**
 * Projeção das faturas do próximo mês.
 *
 * O SNAPSHOT das 21h do último dia é o contrato da geração do dia 1 — por isso
 * só ele aceita ajuste.
 */
export const ProjectionService = {
  async get(month?: string, kind?: 'PREVIA' | 'SNAPSHOT'): Promise<Projection | null> {
    const r = await api.get<{ data: Projection | null }>('/financial/revenues/projection', {
      params: { month, kind },
    })
    return r.data.data
  },

  async adjust(itemId: string, payload: { total?: number; dueDate?: string; skipped?: boolean; note?: string }) {
    return api.put(`/financial/revenues/projection/items/${itemId}`, {
      total: payload.total,
      due_date: payload.dueDate,
      skipped: payload.skipped,
      adjust_note: payload.note,
    })
  },
}
